import {Component, Input, OnInit} from '@angular/core';
import {Tab} from '@models/tab';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import * as $ from 'jquery';

@Component({
    selector: 'app-ad-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

    @Input() tabs: Tab[];
    @Input() favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    @Input() path = '';

    // Mobile : changer d'onglet REMPLACE l'entrée d'historique au lieu d'empiler,
    // pour que le retour natif (geste du bord gauche) ramène à la liste comme la
    // flèche retour, et non à chaque onglet visité
    replaceHistory = window.innerWidth < 768;

    constructor() {
    }

    ngOnInit() {
    }


}
